module.exports = __webpack_public_path__ + "img/03-livepen.29cfbe62.png";